<div class="container-fluid">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-md-8 col-lg-6">
      <div class="card mt-2 mb-2">
        <div class="card-body p-4 g-3">
          <h4 i18n>Settings</h4>
          <span class="float-end text-end">
            <input #pictureInput type="file" style="display: none;" accept="image/*" (change)="pictureUpload($event)">
            <button type="button" class="btn btn-primary" (click)="pictureInput.click()"><fa-icon [icon]="fa.faCamera"
                style="color:#fff; position: relative; top: -2px;"></fa-icon></button>
          </span>
          <img #pictureTag [src]="'/api/customer/contacts/' + contact.id + '/picture' | authImg | async"
            style="border-radius: 50%; height: 5rem; width: 5rem; border: 1px solid #ccc;" class="float-start me-3">
          <span class="clearfix"></span>
          <div class="mt-3 mb-3">
            <div *ngIf="organization.id && contact"><strong i18n>Customer ID:</strong> {{ organization.country_code.toLocaleUpperCase()}}-{{ contact.id }}
            </div>
            <div><strong i18n>Customer since:</strong> {{ contact.created_at | date: 'shortDate' }}</div>
          </div>
          <button type="button" class="btn btn-primary float-end" (click)="personalInfo()" i18n>Edit</button>
          <h5 i18n>Personal information</h5>
          <span class="text-muted">
            <div>{{ contact.first_name }} {{ contact.last_name }}</div>
            <div>{{ contact.email }}</div>
            <div *ngIf="contact.mobile_phone">{{ contact.mobile_phone }}</div>
          </span>
          <h5 class="mt-3" i18n>Locations</h5>
          <div *ngFor="let customer of customers" class="card mb-2 cursor-pointer" (click)="editLocation(customer)">
            <div class="card-header rounded d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div>
                  <div *ngIf="customer.type != 'individual'">
                    <strong>{{ customer.name }}</strong>
                  </div>
                  {{ customer.street_address }} {{ customer.office }} {{ customer.city }}
                </div>
              </div>
              <div class="d-flex align-items-center">
                <span *ngIf="customer.id == contact.default_customer_id" class="badge rounded-pill bg-primary"
                  i18n>Default</span>
                <fa-icon [icon]="fa.faChevronCircleRight" style="font-size: 1.5rem;" class="ms-3"></fa-icon>
              </div>
            </div>
          </div>
          <div class="card cursor-pointer" (click)="editLocation(null)">
            <div class="card-header rounded d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center" i18n>Add new location</div>
              <fa-icon [icon]="fa.faChevronCircleRight" style="font-size: 1.5rem;" class="ms-3"></fa-icon>
            </div>
          </div>

          <h5 class="mt-3" i18n>Payment cards</h5>
          <div class="card mb-2 cursor-pointer" *ngFor="let card of contact.cards" (click)="editCard(card)">
            <div class="card-header rounded d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div>
                  <div>
                    {{ card.number }}
                  </div>
                  <span i18n>Expires:</span>&nbsp;{{ card.expire_month | number: '2.0-0' }}/{{ card.expire_year }}
                </div>
              </div>
              <div class="d-flex align-items-center">
                <span *ngIf="card.id == contact.default_card_id" class="badge rounded-pill bg-success"
                  style="position: relative; top: -2px;" i18n>Default</span>
                <fa-icon [icon]="fa.faChevronCircleRight" style="font-size: 1.5rem;" class="ms-3"></fa-icon>
              </div>
            </div>
          </div>
          <div class="card mb-3 cursor-pointer" (click)="addCard()">
            <div class="card-header rounded d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center" i18n>Add new card</div>
              <fa-icon [icon]="fa.faChevronCircleRight" style="font-size: 1.5rem;" class="ms-3"></fa-icon>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-12">
              <button type="button" (click)="referrals()" class="btn btn-primary w-100" i18n>Earn referral
                discounts</button>
            </div>
            <div class="col-12">
              <button type="button" (click)="discounts()" class="btn btn-primary w-100" i18n>Discounts</button>
            </div>
            <div class="col-12">
              <button type="button" (click)="paymentHistory()" class="btn btn-primary w-100" i18n>Payment
                history</button>
            </div>
            <div class="col-12">
              <a routerLink="/change-password" class="btn btn-primary w-100" i18n>Change password</a>
            </div>
            <div class="col-12">
              <button type="button" (click)="removeAccount()" class="btn btn-danger w-100" i18n>Remove
                account</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>